// extracted by mini-css-extract-plugin
export var content = "styles-module--content--bd015";
export var image = "styles-module--image--720a4";
export var wrapper = "styles-module--wrapper--ecabd";